import { Link } from "react-router-dom";

import imgAveritas from "../../assets/images/img-averitas-logo.svg";



export default function MyQCFooter(): JSX.Element {
  return (
      <footer id="need-help-section" style={{scrollMarginTop:'150px'}}>
          <div className="container container-small">
              <div className="footer-header text-light">
                  <h2 className="m-0 ps-2 ps-lg-3">Need Help?</h2>
                  <hr className="mt-2 mb-4" />
                  <h6 className="mb-0 fw-bold ps-2 ps-lg-3">We’re here for you.</h6>
              </div>
          </div>
          <div className="top-footer text-light">
              <div className="container container-small">
                  <div className="row justify-content-around pb-4">
                      <div className="col-lg-5 d-flex align-items-center flex-column gap-3">
                          <Link to="https://www.qutenzahcp.com/request-a-rep" target="_blank" type="button"
                                className="btn-home btn-yellow d-flex align-items-center gap-3">
                              Access/Reimbursement Questions?
                              <svg width="8" height="14" viewBox="0 0 8 14" fill="none"
                                   xmlns="http://www.w3.org/2000/svg">
                                  <path
                                      d="M5.48206 7.01292L0.318462 1.80787C0.218831 1.71087 0.139361 1.59484 0.0846906 1.46655C0.0300201 1.33826 0.00124292 1.20028 3.93064e-05 1.06066C-0.00116431 0.921042 0.0252294 0.782578 0.07768 0.653349C0.13013 0.524121 0.207588 0.406715 0.305532 0.307985C0.403476 0.209254 0.519946 0.131175 0.648145 0.0783035C0.776345 0.0254319 0.913706 -0.0011733 1.05222 3.9951e-05C1.19072 0.00125321 1.32761 0.0302609 1.45487 0.0853702C1.58214 0.14048 1.69725 0.220587 1.79348 0.321018L7.69458 6.26949C7.89014 6.46668 8 6.73409 8 7.01292C8 7.29175 7.89014 7.55916 7.69458 7.75635L1.79348 13.7048C1.59674 13.8964 1.33324 14.0024 1.05972 14C0.786214 13.9976 0.524579 13.887 0.33117 13.692C0.137762 13.4971 0.0280543 13.2333 0.0256775 12.9576C0.0233007 12.6819 0.128445 12.4163 0.318463 12.218L5.48206 7.01292Z"
                                      fill="#212529"/>
                              </svg>
                          </Link>
                          <div className="footer-text text-center">
                              <p className="m-0">
                                  <b>
                                      Click above to request an MQC representative or call My QUTENZA Connect at
                                      855-802-8746
                                  </b>
                                  <span className="fax-text"> (fax: 855-454-8746)</span>
                              </p>
                              {/*<p className="m-0">*/}
                              {/*    <b>Click above to request an MQC representative or call My QUTENZA Connect at 855-802-8746 </b>*/}
                              {/*    (fax: 855-454-8756)*/}
                              {/*</p>*/}
                          </div>
                      </div>
                      <div className="col-lg-1 footer-or-divider fw-bold my-4 my-lg-3">
                          <span>OR</span>
                      </div>
                      <div className="col-lg-5 d-flex align-items-center flex-column gap-3">
                          <Link to="https://www.qutenzahcp.com/request-a-rep" target="_blank" type="button"
                                className="btn-home btn-yellow d-flex align-items-center gap-3">
                              Treatment Questions?
                              <svg width="8" height="14" viewBox="0 0 8 14" fill="none"
                                   xmlns="http://www.w3.org/2000/svg">
                                  <path
                                      d="M5.48206 7.01292L0.318462 1.80787C0.218831 1.71087 0.139361 1.59484 0.0846906 1.46655C0.0300201 1.33826 0.00124292 1.20028 3.93064e-05 1.06066C-0.00116431 0.921042 0.0252294 0.782578 0.07768 0.653349C0.13013 0.524121 0.207588 0.406715 0.305532 0.307985C0.403476 0.209254 0.519946 0.131175 0.648145 0.0783035C0.776345 0.0254319 0.913706 -0.0011733 1.05222 3.9951e-05C1.19072 0.00125321 1.32761 0.0302609 1.45487 0.0853702C1.58214 0.14048 1.69725 0.220587 1.79348 0.321018L7.69458 6.26949C7.89014 6.46668 8 6.73409 8 7.01292C8 7.29175 7.89014 7.55916 7.69458 7.75635L1.79348 13.7048C1.59674 13.8964 1.33324 14.0024 1.05972 14C0.786214 13.9976 0.524579 13.887 0.33117 13.692C0.137762 13.4971 0.0280543 13.2333 0.0256775 12.9576C0.0233007 12.6819 0.128445 12.4163 0.318463 12.218L5.48206 7.01292Z"
                                      fill="#212529"/>
                              </svg>
                          </Link>
                          <div className="footer-text text-center">
                              <p className="fw-bold">
                                  Click above to connect with an Averitas Representative for training support or
                                  clinical questions
                              </p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div className="bottom-footer py-5 pb-4 bg-white">
              <div className="container">
                  <p className="mb-4 reference-text"><b>Reference: 1.</b> Averitas Pharma, Inc. Data on file. My QUTENZA Connect (MQC), 2025.</p>
                  <div className="page-links d-flex flex-column flex-lg-row gap-3">
                      <a href="/users/sign_in" target="_blank" className="text-link-purple">Benefit Investigation Portal</a>
                      <a href="https://patientcostsavings.qutenza.com/" target="_blank" className="text-link-purple" rel="noreferrer">Cost Savings Portal</a>
                      <a href="https://www.qutenzapatientsavings-sp.com/" target="_blank" className="text-link-purple" rel="noreferrer">Copay Card Generator</a>
                      <a href="/resources" className="text-link-purple">Resources</a>
                  </div>
                  <hr className="mt-4 mb-2" />
                  <div className="footer-links d-flex flex-column flex-lg-row gap-2 gap-lg-4 mb-3">
                      <Link to="https://www.averitaspharma.com/privacy-statement/" target="_blank" className="text-dark">Privacy and Cookies Policy</Link>
                      <Link to="https://www.averitaspharma.com/terms-of-use/" target="_blank" className="text-dark">Terms of Use</Link>
                      <Link to="https://www.qutenzahcp.com/pdfs/qutenza_prescribing_information.pdf" target="_blank"
                            rel="noopener noreferrer" className="text-dark">Full Prescribing Information</Link>
                      <Link to="https://www.averitaspharma.com/" target="_blank" className="text-dark">AveritasPharma.com</Link>
                  </div>
                  <div className="footer-trademark d-flex flex-column flex-md-row justify-content-between">
                      <a className="mb-2 mb-lg-0" href="https://www.averitaspharma.com/" target="_blank" rel="noopener noreferrer">
                          <img src={imgAveritas} alt="dashboard icon" width="120" height="62"/>
                      </a>
                      <div className="trademark-text text-md-end text-start">
                          <p className="m-0">QUTENZA<sup>®</sup> is a registered trademark of Averitas Pharma, Inc.</p>
                          <p className="m-0">©2026 Averitas Pharma, Inc. All rights reserved.</p>
                          <p className="m-0">QZA-12-25-0021 v2.0 February 2026</p>
                      </div>
                  </div>
              </div>
          </div>
      </footer>
  )
}
